import { Action } from '@ngrx/store';
import { Deal, DealVersionSelector } from '../../types/deal.types';

export enum DealActionTypes {
  Load = '[Deal] Load',
  Reload = '[Deal] Reload',
  LoadSuccess = '[Deal] Load Success',
  LoadFail = '[Deal] Load Fail',
  Reset = '[Deal] Reset',
  SetVersion = '[Deal] Set version',
  SetUseDefaultVersion = '[Deal] Set Default version'
}

export class Load implements Action {
  public readonly type = DealActionTypes.Load;

  constructor(public payload: string) {}
}

export class ReLoad implements Action {
  public readonly type = DealActionTypes.Reload;

  constructor(public payload: string) {}
}

export class LoadSuccess implements Action {
  public readonly type = DealActionTypes.LoadSuccess;

  constructor(
    public payload: { deal: Deal; defaultVersion: DealVersionSelector }
  ) {}
}

export class LoadFail implements Action {
  public readonly type = DealActionTypes.LoadFail;

  constructor(public payload: string) {}
}

export class Reset implements Action {
  public readonly type = DealActionTypes.Reset;
}

export class SetVersion implements Action {
  public readonly type = DealActionTypes.SetVersion;

  constructor(public payload: DealVersionSelector) {}
}

export class SetUseDefaultVersion implements Action {
  public readonly type = DealActionTypes.SetUseDefaultVersion;
}

export type DealActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | ReLoad
  | Reset
  | SetVersion
  | SetUseDefaultVersion;
